var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-ac-enroll-audit" }, [
    _c("div", { staticClass: "standard-size-16 color-gray-10" }, [
      _c(
        "div",
        { staticClass: "mb32 font-bolder" },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_ac_enroller_info" /** 申请人信息 */)) +
              "\n      "
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 12 } },
                [
                  _c("span", { staticClass: "color-gray-7 nowrap" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_ac_enroller_name" /** 姓名 */)) +
                        "："
                    ),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    { attrs: { "open-filter": true, placement: "top" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("yxtbiz-user-name", {
                            attrs: { name: _vm.detail.fullname || "--" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "yxtbiz-teacher-enroll-audit_ellipsis" },
                        [
                          _c("yxtbiz-user-name", {
                            attrs: { name: _vm.detail.fullname || "--" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 12 } },
                [
                  _c("span", { staticClass: "color-gray-7 nowrap" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_ac_enroller_dept" /**  部门 */)) +
                        "："
                    ),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    { attrs: { "open-filter": true, placement: "top" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("yxtbiz-dept-name", {
                            attrs: { name: _vm.detail.deptName || "--" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "yxtbiz-teacher-enroll-audit_ellipsis" },
                        [
                          _c("yxtbiz-dept-name", {
                            attrs: { name: _vm.detail.deptName || "--" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 12 } },
                [
                  _c("span", { staticClass: "color-gray-7 nowrap" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_ac_enroller_possion" /**岗位 */)) +
                        "："
                    ),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    { attrs: { "open-filter": true, placement: "top" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("yxtbiz-position-name", {
                            attrs: {
                              name: _vm.detail.positionNameList || "--",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "yxtbiz-teacher-enroll-audit_ellipsis" },
                        [
                          _c("yxtbiz-position-name", {
                            attrs: {
                              name: _vm.detail.positionNameList || "--",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mb32 font-bolder" },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_ac_enroll_acinfo" /** 活动信息 */)) +
              "\n      "
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 12 } },
                [
                  _c("span", { staticClass: "color-gray-7 nowrap" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pc_biz_ac_enroll_acname" /** 活动名称 */)
                      ) + "："
                    ),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    {
                      attrs: {
                        "open-filter": true,
                        content: _vm.detail.projectName,
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-teacher-enroll-audit_ellipsis" },
                        [_vm._v(_vm._s(_vm.detail.projectName || "--"))]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }